import {get,post} from "@/utils/request.js"

/* 
	公共页面调用
 */
//获取地址信息
export function selByList(data){
	return post('/admin/appCAddress/selByList',data)
}
// 获取商品信息
export function getAppCCartByIds(data){
	return post('/admin/appCCart/getAppCCartByIds',data)
}
// 优惠券信息
export function yHselByList(data){
	return post('/admin/appCUserCoupon/selByList',data)
}
// 运费计算
export function getFreightByAddress(data){
	return post('/app/appCFreight/getFreightByAddress',data)
}
// 下单接口
export function appUserPlaceOrder(data){
	return post('/admin/appCUserorder/appUserPlaceOrder',data)
}